// @ts-nocheck
/* eslint-disable */
import { CONFIG } from "~/config";
import Scene from "~/scene";
import { _ } from "~/i18n";
import { IRouteConst, ROUTE_CONST } from "~/route/const";
import { description, getIcon } from "~/util/providers/poiagg";
import { getLocation } from "~/whereami";
import { getRouteSubtitle } from "~/util/route";
import { TActivityType } from "~/interfaces";
import { MAX_TITLE_LEN } from "~/ui/dialogs/const";
import WasmStoreMarker from "~/wasm/store/wasm-store-marker";

// parametry pro volani FRPC
const DESC_PARAMS = {
	fetchPhoto: true,
	ratios: [
		"3x2"
	],
	lang: CONFIG.langPriority,
	wikimedia: true,
};

let utils = {};
/**
 * Ziskani dat pro volani FRPC.
 *
 * @return  {Array}
 */
export function providerParams(routeState): [Array<any>, {
	[key: string]: any;
}] {
	let items = [];
	let len = routeState.items.length;
	let pubtInd = 0;

	routeState.items.forEach((data, ind) => {
		let item = {
			id: data.id,
			source: data.source,
			geometry: data.geometry,
			descParams: DESC_PARAMS,
			...data.favoriteId ? { favoriteId: data.favoriteId } : {},
		};

		if (ind != len - 1) {
			item.routeParams = {
				criterion: routeState.params.criterion
			};

			// vsichni krome pubt to maji dobrovolne, takze pokud neni vyplneno, neposilame
			if (routeState.params.datetime
				&& (
					(Mapy.CUS?.route?.datetimeForAll && [ROUTE_CONST.types.ski.def, ROUTE_CONST.types.water.def].indexOf(routeState.params.criterion) === -1)
					|| routeState.params.criterion === ROUTE_CONST.types.pubt.def
				)
			) {
				item.routeParams.datetime = routeState.params.datetime;
			}
			if ("departure" in routeState.params
				&& (
					(Mapy.CUS?.route?.datetimeForAll && [ROUTE_CONST.types.ski.def, ROUTE_CONST.types.water.def].indexOf(routeState.params.criterion) === -1)
					|| routeState.params.criterion === ROUTE_CONST.types.pubt.def
				)
			) {
				item.routeParams.departure = routeState.params.departure;
			}

			if (!Mapy.CUS.userweb.routeNewHD && item.routeParams.criterion == ROUTE_CONST.types.pubt.def) {
				// pubt kdyz cas nema, musime dodat cas TED
				item.routeParams.datetime = routeState.params.datetime || Mapy.Util.dateToISO((new Date()));
				item.routeParams.departure = routeState.params.departure;

				if (routeState.pubtIndex.length) {
					item.routeParams.index = routeState.pubtIndex[pubtInd] || 0;
				}

				if (routeState.params.criterionSpecs && Object.keys(routeState.params.criterionSpecs).length) {
					item.routeParams.criterionSpecs = routeState.params.criterionSpecs;
				}

				pubtInd++;
			}
		}

		items.push(item);
	});

	let options = {
		tollExcludeCountries: routeState.params.excludeCountries || [],
		useTraffic: !!routeState.params.useTraffic,
	};

	if (items.length == 1 && routeState.items[0].planTrip) {
		// vyletum nechceme posilat true pro useTraffic nikdy
		options.useTraffic = false;

		items[0].tripParams = {
			criterion: routeState.params.tripCriterion
		};

		// waypoints & trip index
		if (routeState.params.waypoints) {
			items[0].tripParams.waypoints = routeState.params.waypoints;
		}
		else {
			items[0].tripParams.tripIndex = routeState.params.tripIndex || 0;
		}
	}

	if (routeState.itinerary) {
		options.itinerary = true;

		if (routeState.routingId) {
			options.routing_id = routeState.routingId;
		}
	}

	if (routeState.routeWaypoints && routeState.routeWaypoints != "") {
		options.routeWaypoints = routeState.routeWaypoints;
	}

	if (Mapy.CUS.userweb.routeNewHD && routeState.params.flags && routeState.params.criterion === ROUTE_CONST.types.pubt.def) {
		options.pubtv3 = {
			...routeState.params.flags,
			count: routeState.numOfFirstLoadItem,
			markmidpoints: true,
		};

		if (options.pubtv3.tcount) {
			options.pubtv3.tcount = 0;
		} else {
			delete options.pubtv3.tcount;
		}
	}

	if (routeState.params.avoidHighways) {
		options.avoidHighways = routeState.params.avoidHighways;
	}

	if (routeState.params.allowViaFerrata) {
		options.allowViaFerrata = routeState.params.allowViaFerrata;
	}

	return [items, options];
};

/**
 * Ziskani textu s pozici.
 *
 * @param   {Number}  position Enum pozice
 * @param   {Number}  ind  Poradi
 * @return {String}
 */
export function getPosition(position, ind = 0) {
	return (position == ROUTE_CONST.position.start ? _("route.item.start") : (position == ROUTE_CONST.position.end ? _("route.item.end") : _("route.item.waypoint", {
		number: ind + 1
	})));
};

/**
 * Ziskani li elementu z dat.
 *
 * @param {Object} data
 * @param {SceneLayer} layer - kam pripnout marker?
 * @return {Element} li
 */
export function getTripPOI(data, layer) {
	let li = Mapy.Util.node("li", { title: data.title });
	let coords = Scene.coordsFromWGS84(data.mark.lon, data.mark.lat);
	let urlImg = "";
	let urlIcon = "";
	if (data.icon) {
		urlImg = Mapy.CDN.setSize(data.icon, Mapy.CDN.SIZE_40_40);
	}
	else {
		urlIcon = getIcon(data.typeId);
	}
	let marker = Scene.createMarkerPOI(coords, null, {
		visual: urlImg || urlIcon ? Scene.VISUAL.MARKER_POI.SMALL : Scene.VISUAL.MARKER_POI.UNIVERSAL,
		url: urlImg,
		urlPoitype: urlIcon ? urlIcon : null
	});

	const wasmMarker = new WasmStoreMarker({
		type: "small-gray",
		lon: data.mark.lon,
		lat: data.mark.lat,
		visible: false,
		// zrovna dame do popredi
		bringToTheFront: true,
		img: urlImg || urlIcon,
	});

	li.addEventListener("click", e => {
		Mapy.getComponent("detail").setState({
			id: data.id,
			source: data.source,
			show: false
		}).then(() => Mapy.getComponent("history").save(), () => {});
	});
	li.addEventListener("mouseenter", e => {
		layer.addMarker("search", marker, data.source, data.id);
		wasmMarker.update({
			visible: true,
		});
	});
	li.addEventListener("mouseleave", e => {
		layer.removeMarker(marker);
		wasmMarker.update({
			visible: false,
		});
	});
	let icon = Mapy.Util.node("span", { className: "icon" });
	let iconImg = new Image();

	if (CONFIG.wasmEnabled) {
		iconImg.crossOrigin = "anonymous";
	}

	iconImg.src = urlImg || urlIcon;
	icon.append(iconImg);
	let text = Mapy.Util.node("div", { className: "text" });
	let title = Mapy.Util.node("h4", { textContent: data.title });
	li.appendChild(icon);
	li.appendChild(text);
	text.appendChild(title);

	return {
		li,
		wasmMarker,
	};
};

/**
 * Vrat enum pomoci typu a route name.
 *
 * @param {Number} vehicleType
 * @param {String} routeName
 */
export function itineraryPubtTypeName(vehicleType, routeName) {
	switch (vehicleType) {
		case 1: return "bus-city";
		case 2: return "tram";
		case 3: return "cable";
		case 4:
			switch (routeName) {
				case "B": return "metro-b";
				case "C": return "metro-c";
				case "A": return "metro-a";
				default: return "metro";
			}
		case 5: return "ferry";
		case 6: return "trolley";
		case 7: return "train";
	}

	return "pedestrian";
};

export function replaceOldCriterion(oldCriterion, toll = "") {
	var newCriterion;

	switch (oldCriterion) {
		case 1:
			newCriterion = toll === "free" ? 112 : 111;
			break;
		case 2:
			newCriterion = toll === "free" ? 113 : 114;
			break;
		case 11:
		case 12:
		case 24:
			newCriterion = 121;
			break;
		case 13:
			newCriterion = 122;
			break;
		case 21:
			newCriterion = 131;
			break;
		case 22:
		case 32:
			newCriterion = 132;
			break;
		case 31:
		case 41:
			newCriterion = 141;
			break;
		case 43:
			newCriterion = 144;
			break;
		case "pubt":
			newCriterion = 200;
			break;
		default:
			newCriterion = null;
	}

	return newCriterion;
};

export function getExportState() {
	let routeState = Mapy.CML.state.route;
	let state = {
		lang: [encodeURIComponent(CONFIG.langPriority.join(","))], // pozadovane jazyky v poradi priority
		rp_c: [routeState.params.criterion], // planovaci kriterium pro trasu
		xc: routeState.params.excludeCountries
	};
	let coords = [];
	let rs = [];
	let ri = [];

	routeState.items.forEach(i => {
		coords.push(i.geometry);
		rs.push(i.source ? i.source : "");
		ri.push(i.source != "coor" && i.id ? i.id : "");

		if (i.tripData[routeState.index]) {
			// planovaci kriterium pro vylet
			state.tp_c = [routeState.params.tripCriterion];

			// waypointy pro rucne upraveny vylet
			if (routeState.params.waypoints != "") {
				state.tp_w = [routeState.params.waypoints];
			}

			// index vybraneho vyletu
			state.tp_i = [routeState.params.tripIndex];
		}
	});

	/**
	 * trojice urcujici body pres ktere se planuje, rs a ri je source a id poie,
	 rg je souradnice, mohou se opakovat, poradi v url je zavazne
		*/
	state.rg = coords;
	state.rs = rs;
	state.ri = ri;

	// planovani s dopravou
	if (routeState.params.useTraffic) {
		state.rut = [1];
	}

	const rbf = [];

	if (routeState.params.avoidHighways) {
		rbf.push("ah");
	}

	if (routeState.params.allowViaFerrata) {
		rbf.push("avf");
	}

	if (rbf.length) {
		state.rbf = rbf;
	}

	// planovani MHD musi dostat jeste indexy tras
	if (ROUTE_CONST.types.pubt.criterion.indexOf(routeState.params.criterion) > -1) {
		state.rp_pt = [encodeURIComponent(routeState.params.datetime || Mapy.Util.dateToISO((new Date())))];
		if (routeState.pubtIndex.length) {
			const indexes = Array.from(routeState.pubtIndex);

			indexes.push(0);
			state.rp_pi = [encodeURIComponent(indexes.join(','))];
		}
	}

	if (routeState.responseData[routeState.index].routeId) {
		state.route_id = [routeState.responseData[routeState.index].routeId];
	}
	else if (routeState.responseData[routeState.index].routeWaypoints) {
		state.rp_aw = [routeState.responseData[routeState.index].routeWaypoints];
	}

	if (routeState.likeData?.usertitle && routeState.likeData.usertitle != "") {
		const ut = routeState.likeData.usertitle;
		state.name = [encodeURI(ut.length < 100 ? ut : ut.substring(0,100))];
	}

	if (routeState.likeData) {
		state.title = routeState.likeData.usertitle || routeState.likeData.title;
	}

	return state;
};

export function getModulesData() {
	let routeState = Mapy.CML.state.route;
	let items = routeState.items || [];
	let isTrip = items.length && items[0].tripData[routeState.index];

	let title = _("route.favouriteTitle", items[0].title, items[items.length - 1].title);

	if (isTrip && items.length == 3) {
		title = _("route.favouriteCircuitTitle", items[0].title);
	}
	else if (isTrip) {
		title = _("route.favouriteCircuitRouteTitle", items[0].title, items[items.length - 1].title);
	}

	// odstranime vlastni veci z items
	items.forEach(i => {
		["images", "path", "tripData", "pubtData", "boatData", "routeData", "ind", "position", "showTrip"].forEach(key => {
			if (key in i) {
				delete i[key];
			}
		});

		i.routeParams = {
			criterion: routeState.params.criterion,
		};

		if ("datetime" in routeState.params) {
			i.routeParams.datetime = routeState.params.datetime;
		}

		if ("departure" in routeState.params) {
			i.routeParams.departure = routeState.params.departure;
		}

		if (routeState.params.criterion == ROUTE_CONST.types.pubt.def) {
			i.routeParams.departure = routeState.params.departure;

			if ("datetime" in routeState.params) {
				i.routeParams.datetime = routeState.params.datetime;
			}
			if (routeState.pubtIndex.length) {
				i.routeParams.index = routeState.pubtIndex || 0;
			}

			i.routeParams.mobile = false;
		}

		if (isTrip) {
			i.tripParams = {
				tripIndex: routeState.params.tripIndex,
				criterion: routeState.params.tripCriterion
			};

			if (routeState.params.waypoints && routeState.params.waypoints != "") {
				i.tripParams.waypoints = routeState.params.waypoints;
			}
		}
	});

	let saveData = {
		title: title.slice(0, MAX_TITLE_LEN).trim(),
		geometry: routeState.responseData[routeState.index].geometry,
		subtitle: getRouteSubtitle(routeState.responseData[routeState.index].totalLength, routeState.responseData[routeState.index].totalTime),
		items,
		// podpora pro getCreateLikeData
		routeItems: items,
		routeParams: {
			allowViaFerrata: routeState.params.allowViaFerrata,
			avoidHighways: routeState.params.avoidHighways,
			tollExcludeCountries: routeState.params.excludeCountries,
			useTraffic: !!routeState.params.useTraffic,
		},
		totalLength: routeState.responseData[routeState.index].totalLength,
		totalTime: routeState.responseData[routeState.index].totalTime
	};

	if (routeState.responseData[routeState.index].routeId) {
		saveData.routeParams.route_id = routeState.responseData[routeState.index].routeId;
	}

	if (routeState.likeData) {
		if ("usertitle" in routeState.likeData) {
			saveData.usertitle = routeState.likeData.usertitle;
		}

		if (routeState.likeData.description) {
			saveData.description = routeState.likeData.description;
		}
	}

	if (routeState.responseData[routeState.index].routeWaypoints) {
		saveData.routeParams.routeWaypoints = routeState.responseData[routeState.index].routeWaypoints;
	}

	return saveData;
};

interface IGetPOI {
    id: number;
    images: any;
    source: string;
    geometry: string;
    title: string;
    desc: string;
}

export function getPOI(coords, noDesc = false): Promise<IGetPOI> {
	return new Promise(resolve => {
		getLocation(coords).then(data => {
			let itemData: IGetPOI = {
				id: data.id,
				images: null,
				source: data.source,
				geometry: Scene.coordsToString([coords]),
				title: data.label,
				desc: "",
			};

			// analytika
			let wgs84 = coords.toWGS84();
			Mapy.getComponent("logger").log("route-rgeocode", {
				itemx: wgs84[0].toFixed(6),
				itemy: wgs84[1].toFixed(6),
				id: data.id,
				source: data.source,
				text: data.label
			});

			if (noDesc) {
				resolve(itemData);
			} else {
				description([data], {
					"fetchPhoto": true,
					"ratios": ["3x2"],
					"lang": CONFIG.langPriority,
					wikimedia: true,
				}).then(r => {
					if (r.poi.length) {
						let poi = r.poi[0];

						Object.assign(itemData, {
							images: poi.media ? poi.media.urls : null,
							title: poi.title,
							desc: poi.multiTitle ? poi.multiTitle.join(", ") : (poi.desc || poi.description || "")
						});
					}

					resolve(itemData);
				}, e => {
					resolve(itemData);
				});
			}
		}, () => {});
	});
};

export function paramTypeToSvg(routeState) {
	let svg = "";

	Object.keys(ROUTE_CONST.types).every(key => {
		let item = ROUTE_CONST.types[key];

		if (item.type == routeState.params.type) {
			svg = item.svg;
		}
		else return true;
	});

	return svg;
};

export function getRouteTripType(tripParams) {
	const keys = Object.keys(ROUTE_CONST.circuitTypes);
	let type = ROUTE_CONST.TYPE_WALK;

	keys.forEach(key => {
		let type = ROUTE_CONST.circuitTypes[key];

		if (type.criterion.indexOf(tripParams.criterion) > -1) {
			type = type.type;
		}
	});

	return type;
}

export function getTypeFromCriterion(criterion) {
	let routeType = "";

	Object.values(ROUTE_CONST.types).forEach(type => {
		if (type.criterion.indexOf(criterion) > -1) {
			routeType = type.type;
		}
	});

	return routeType;
}

export const criterionActivityMappingTable: {[key: TActivityType]: Array<number>} = {
	// auto
	"auto_moto": [111, 112, 113, 114],
	// pesky
	"beh": [134],
	"pesky": [131, 132],
	"kocarek": [133],
	// kolo
	"gravel": [124],
	"horske_kolo": [123],
	"kolobezka": [125],
	"nakole": [121],
	"silnicni_kolo": [122],
	// lyze
	"bezky": [141],
	"skialpy": [142],
	// voda
	"vodactvi": [144],
};

export function criterion2activityType(criterion: number): TActivityType | null {
	const allTypes = Object.keys(criterionActivityMappingTable);

	for (const type of allTypes) {
		const criterions = criterionActivityMappingTable[type];

		if (criterions.includes(criterion)) {
			return type as TActivityType;
		}
	}

	return null;
}

export function activityTypes2criterions(activityTypes: Array<TActivityType>) {
	let allCriterions: Array<number> = [];

	for (const activity of activityTypes) {
		if (activity in criterionActivityMappingTable) {
			allCriterions = allCriterions.concat(criterionActivityMappingTable[activity]);
		}
	}

	return allCriterions;
}
